var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "kpi-table__metric" }, [
    _c("td", { staticClass: "metric--name" }, [
      _vm._v(_vm._s(_vm.displayTitle))
    ]),
    _c("td", { staticClass: "metric--benchmark-low" }, [
      _vm._v(_vm._s(_vm.low_value_monthly))
    ]),
    _c("td", { staticClass: "metric--benchmark-median" }, [
      _vm._v(_vm._s(_vm.median_value_monthly))
    ]),
    _c("td", { staticClass: "metric--benchmark-high" }, [
      _vm._v(_vm._s(_vm.high_value_monthly))
    ]),
    _c("td", { staticClass: "metric--your-practice" }, [
      _vm._v(_vm._s(_vm.previousYtd))
    ]),
    _c("td", { staticClass: "metric--your-practice" }, [
      _vm._v(_vm._s(_vm.actualYtd))
    ]),
    _c("td", { staticClass: "metric--plus-minus" }, [
      _c("span", { staticClass: "glyphicon", class: _vm.targetBenchmarkClass })
    ]),
    _c("td", { staticClass: "metric--plus-minus" }, [
      _vm._v(_vm._s(_vm.benchmarkDiffDisplay))
    ]),
    _c(
      "td",
      { class: "comment comments_" + _vm.field, attrs: { rowspan: "2" } },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: { content: _vm.comment, html: true },
                expression: "{ content:comment, html:true }"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.commentShort))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }